import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  SimulateActionTypes,
  SimulateActions,
} from '@ordersnproducts/modules/order-builder/modules/rms-summary/actions/open-platform/simulate.actions';
import { OrderULResponse } from '@cemex-core/cmx-api';

export interface SimulateState {
  loading: boolean;
  simulateResponse: OrderULResponse;
}

export const initialState: SimulateState = {
  loading: false,
  simulateResponse: null,
};

export function simulateReducer(state = initialState, action: SimulateActions | OrderBuilderActions): SimulateState {
  switch (action.type) {
    case SimulateActionTypes.LOAD: {
      return {
        ...state,
        ...initialState,
        loading: true,
      } as SimulateState;
    }
    case SimulateActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        simulateResponse: action.payload,
      } as SimulateState;
    }
    case RESET_BUILDER:
    case SimulateActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
